import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  textBig: {
    color: Colors.white, textAlign: 'center', fontFamily: 'MBold',
  },
  imageBig: {
    opacity: 0.4, position: 'absolute', height: '100%', width: '100%', borderRadius: pixelDimensions(3),
  },
  gradient: { borderRadius: pixelDimensions(3) },
  buttonBig: {
    width: '100%',
    height: '100%',
  },
  buttonCorporative: {
    marginVertical: pixelDimensions(2),
    marginHorizontal: pixelDimensions(4),
    paddingVertical: pixelDimensions(4),
  },
  header: {
    paddingVertical: pixelDimensions(5),
    justifyContent: 'center',
  },
  viewBase: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: Colors.grey200,
  },
  textButtonCorporative: {
    textAlign: 'center',
    color: Colors.white,
    fontSize: pixelDimensions(6),
  },
  textTitle: {
    fontSize: pixelDimensions(5),
    color: Colors.white,
    textAlign: 'center',
  },
  logo: {
    marginVertical: pixelDimensions(3),
    alignSelf: 'center',
    height: pixelDimensions(17),
    width: pixelDimensions(17) * (75 / 22),
  },
  version: {
    color: '#333333',
    fontSize: 12,
    padding: 0,
    margin: 0,
    alignSelf: 'center',
  },
  viewSeparator: {
    backgroundColor: Colors.grey500,
    height: pixelDimensions(0.5),
    width: '100%',
    marginVertical: pixelDimensions(2),
  },
  viewShadow: {
    width: '90%',
    alignItems: 'center',
    borderRadius: pixelDimensions(3),
    shadowColor: 'rgba(0,0,0,.8)',
    shadowOpacity: 0.8,
    shadowRadius: pixelDimensions(3),
    shadowOffset: {
      height: 5,
      width: 0,
    },
    marginBottom: pixelDimensions(3),
  },
});

export default styles;
